// import React, { useRef, useState } from "react";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import { Checkbox } from "@material-ui/core";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";

// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const MultiSelectAutocomplete = ({
//   label,
//   options,
//   value,
//   onChange,
//   disabled,
// }) => {
//   // console.log(options)
//   // return (
//   const [inputValue, setInputValue] = useState("");
//   const [lastInputValue, setLastInputValue] = useState("");
//   const restoreInputRef = useRef("");

//   return (
//     <Autocomplete
//       multiple
//       disableCloseOnSelect
//       filterSelectedOptions
//       options={options}
//       value={value}
//       inputValue={inputValue}
//       onInputChange={(event, newInputValue, reason) => {
//         if (reason !== "reset") {
//           setInputValue(newInputValue);
//           restoreInputRef.current = newInputValue; // store last input value
//         }
//       }}
//       onChange={(event, newValue) => {
//         // Trigger onChange and restore previous input text
//         onChange(newValue);
//         setTimeout(() => {
//           setInputValue(restoreInputRef.current);
//         }, 0); // delay ensures it's set after MUI clears it
//       }}
//       getOptionLabel={(option) =>
//         `${option.title} ${option.roleType} ${option.email} ${
//           option?.organization?.organizationName || ""
//         }`
//       }
//       renderOption={(props, option, { selected }) => (
//         <Box component="li" {...props}>
//           <Checkbox style={{ marginRight: 8 }} checked={selected} />
//           <Typography variant="body1" sx={{ fontSize: 12 }}>
//             {option.title}
//           </Typography>
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ ml: 1, fontSize: 12 }}
//           >
//             ({option.roleType}
//             {option?.organization?.organizationName
//               ? ` from ${option.organization.organizationName}`
//               : ""}
//             ) {option.email}
//           </Typography>
//         </Box>
//       )}
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           label={label}
//           placeholder="Choose..."
//           variant="outlined"
//         />
//       )}
//       disabled={disabled}
//     />
//   );
// };

// export default MultiSelectAutocomplete;

// import React from 'react';
// import Select, { components } from 'react-select';
// import { Checkbox, Typography, Box } from '@mui/material';

// const MultiSelectReactSelect = ({ label, options, value, onChange, disabled }) => {
//   // Custom rendering of each option with checkbox and labels
//   const CustomOption = (props) => {
//     const { data, isSelected } = props;
//     return (
//       <components.Option {...props}>
//         <Box display="flex" alignItems="flex-start">
//           <Checkbox
//             checked={isSelected}
//             style={{ marginRight: 8 }}
//           />
//           <Box>
//             <Typography variant="body1" sx={{ fontSize: 12 }}>
//               {data.title}
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12 }}>
//               ({data.roleType}
//               {data?.organization?.organizationName ? ` from ${data.organization.organizationName}` : ''})
//               {' '} {data.email}
//             </Typography>
//           </Box>
//         </Box>
//       </components.Option>
//     );
//   };

//   return (
//     <Box>
//       <Typography sx={{ mb: 1 }}>{label}</Typography>
//       <Select
//         isMulti
//         isDisabled={disabled}
//         options={options}
//         value={value}
//         onChange={onChange}
//         getOptionLabel={(option) =>
//           `${option.title} (${option.roleType}${
//             option?.organization?.organizationName ? ` from ${option.organization.organizationName}` : ''
//           }) ${option.email}`
//         }
//         components={{ Option: CustomOption }}
//         closeMenuOnSelect={false} // keeps dropdown open after selection
//         placeholder="Choose..."
//         styles={{
//           control: (base) => ({
//             ...base,
//             minHeight: 40
//           }),
//           menu: (base) => ({
//             ...base,
//             zIndex: 9999
//           }),
//           multiValueLabel: (base) => ({
//             ...base,
//             fontSize: 12
//           })
//         }}
//       />
//     </Box>
//   );
// };

// export default MultiSelectReactSelect;

import React, { useRef, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import { Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import SearchIcon from "@mui/icons-material/Search";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const MultiSelectAutocomplete = ({
  label,
  options,
  value,
  onChange,
  disabled,
  filtertext
}) => {
  const [inputValue, setInputValue] = useState("");
  const restoreInputRef = useRef("");

  // Floating labels sat on top of the field borders here (global CSS interferes
  // with MUI's outlined label), so the fields use static captions + placeholders.
  const fieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      backgroundColor: "#ffffff",
      "& fieldset": { borderColor: "#d0d5dd" },
      "&:hover fieldset": { borderColor: "#98a2b3" },
      "&.Mui-focused fieldset": { borderColor: "#2563eb", borderWidth: "1px" },
    },
    "& .MuiInputBase-input": { fontSize: 14 },
  };

  const captionSx = {
    fontSize: 13,
    fontWeight: 600,
    color: "#344054",
    mb: 0.75,
  };

  return (
    <Box sx={{ width: "100%" }}>
      {label && <Typography sx={captionSx}>{label}</Typography>}
      <Autocomplete
        multiple
        fullWidth
        openOnFocus
        disableCloseOnSelect
        filterSelectedOptions
        noOptionsText="No user found"
        options={options || []}
        value={value}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          // "reset" fires right after a selection - ignoring it keeps whatever
          // was typed, so several users can be picked from one search.
          if (reason === "input") setInputValue(newInputValue);
          else if (reason === "clear") setInputValue("");
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        getOptionLabel={(option) =>
          `${option.title} ${option.roleType} ${option.email} ${
            option?.organization?.organizationName || ""
          }`
        }
        renderOption={(props, option, { selected }) => (
          <Box component="li" {...props}>
            <Checkbox
              style={{ marginRight: 8 }}
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
            />
            <Typography variant="body1" sx={{ fontSize: 12 }}>
              {option.title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ ml: 1, fontSize: 12 }}
            >
              ({option.roleType}
              {option?.organization?.organizationName
                ? ` from ${option.organization.organizationName}`
                : ""}
              ) {option.email}
            </Typography>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            placeholder={
              value?.length ? "" : "Search and select users by name, email or role..."
            }
            sx={fieldSx}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start" sx={{ ml: 0.5, mr: 0 }}>
                    <SearchIcon fontSize="small" sx={{ color: "#98a2b3" }} />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
        ChipProps={{
          size: "small",
          sx: { borderRadius: "8px", fontSize: 12 },
        }}
        disabled={disabled}
      />
    </Box>
  );
};

export default MultiSelectAutocomplete;
